<template>
  <component
    :is="catalogComponent"
    :key="componentKey"
    ref="component"
    :catalog-info="catalogInfo"
    :section-info="sectionInfo"
    :thumbnail-info="thumbnailInfo"
    :multisection-index="multisectionIndex"
  />
</template>
<script setup>
  import { onMounted, computed, defineProps, shallowRef } from 'vue'
  import { getCellType } from '@/common/utils/home/get-cell-type'
  import { getThumbnailInfo } from '@/common/utils/common'

  import TemplateMultiSectionCatalog from '@/components/container/catalog/TemplateMultiSectionCatalog.vue'
  import HighlightCatalog from '@/components/container/catalog/HighlightCatalog.vue'
  import BigBannerCatalog from '@/components/container/catalog/BigBannerCatalog.vue'
  import LiveBigBannerCatalog from '@/components/container/catalog/LiveBigBannerCatalog.vue'
  import PreviewCatalog from '@/components/container/catalog/PreviewCatalog.vue'
  import SingleBannerCatalog from '@/components/container/catalog/SingleBannerCatalog.vue'
  import TemplateError from '@/components/container/template/Error.vue'

  const props = defineProps({
    catalogInfo: {
      type: Object,
      default: null,
    },
    sectionInfo: {
      type: Object,
      default: null,
    },
    multisectionIndex: {
      type: Number,
      default: 0,
    },
  })
  const componentKey = computed(
    () => `${props.multisectionIndex}_${props.catalogInfo?.id}`,
  )
  const cellType = computed(() => getCellType(props.catalogInfo?.elementList))
  const thumbnailInfo = computed(() => getThumbnailInfo(cellType.value))
  const catalogComponent = shallowRef(null)

  const componentLoader = () => {
    switch (cellType.value) {
      case 'band_1':
      case 'band_2':
      case 'band_3':
      case 'band_4':
      case 'band_5':
      case 'band_6':
      case 'band_7':
      case 'band_8':
      case 'band_9':
      case 'band_10':
      case 'band_11':
      case 'band_12':
      case 'band_13':
      case 'band_14':
      case 'band_15':
      case 'band_16':
      case 'band_17':
      case 'band_18':
      case 'band_19':
      case 'band_20':
      case 'band_21':
      case 'band_42':
      case 'band_61':
      case 'band_71':
      case 'band_94':
      case 'band_98':
      case 'band_myview':
      case 'band_image_box':
      case 'band_2_rank':
      case 'band_52':
        return TemplateMultiSectionCatalog

      case 'band_82':
        return PreviewCatalog

      case 'banner_text':
        return BigBannerCatalog

      case 'band_highlight':
        return HighlightCatalog

      case 'banner_2':
      case 'banner_3':
        return SingleBannerCatalog
      case 'band_instantplay_rank':
        return LiveBigBannerCatalog
      // api type 이 catalog 인 새 컴포넌트가 추가 될 경우 dynamic section loader 를 참조하여 컴포넌트 생성 후 사용
      default:
        console.log('error CellType: ', cellType.value)
        return TemplateError
    }
  }

  onMounted(() => {
    catalogComponent.value = componentLoader()
  })
</script>
